import { connect } from 'react-redux';

import PagePublishFlow from './page_publish_flow.jsx';

import {
  openPageDetails
} from 'zoomforth_shared_management/action_creators/modals.js';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  forcePageDataUpdateFromServer
} from 'zoomforth_codesbane_editor/action_creators/pageMeta.js';

import {
  publish,
  requestApproval
} from 'zoomforth_codesbane_editor/action_creators/misc.js';

import { 
  addRouteToRouteCollection
} from 'zoomforth_shared_management/action_creators/page_and_link_management.js';

import { get as getUser } from 'zoomforth_zf/appglobals/user.js';
import { get as getPages } from 'zoomforth_zf/appglobals/pages.js';
import { get as getRoutesForPage } from 'zoomforth_zf/appglobals/routes-by-page.js';
import { get as getDomains } from 'zoomforth_zf/appglobals/domains.js';

import {
  info as showNotificationInfo,
  success as showNotificationSuccess
} from 'zoomforth_app_basics/action_creators/notifications.js';

import {
  subscribeCurrentUserToRouteVisits
} from 'zoomforth_shared_management/action_creators/notification_settings.js';


const mapStateToProps = (state, { pageId }) => {
  return {
    domains: getDomains(),
    page: getPages().get(pageId),
    pageRoutes: getRoutesForPage(pageId),
    user: getUser()
  };
};

const mapDispatchToProps = (dispatch, { pageId }) => (
  {
    onChangeApprovalMessageCreate: (message)=> {
      dispatch(requestApproval(message));
      dispatch(showNotificationSuccess({
        children: 'Sent your message requesting an editor approve and publish this site.'
      }));
    },

    onVisitorAccessSettingsView: ()=> {
      dispatch(openPageDetails(pageId, 'access'));
    },

    onVisitorAccessSettingsReviewSuggest: ()=> {
      dispatch(openPageDetails(pageId, 'access'));
      dispatch(showNotificationInfo({ 
        title: 'Make sure your "Visitor Access" settings are correct.',
        message: 'This is the first time you\'ve published this site.'
      }));
    },

    onPublish: ()=> {
      dispatch(publish(pageId));
    },

    onRequestClose: ()=> {
      dispatch(closeModal());
    },

    onRouteCreate: (route)=> {
      dispatch(addRouteToRouteCollection(route));
      dispatch(forcePageDataUpdateFromServer());
    },

    onSubscribeToRouteClick: (routeId)=> {
      dispatch(subscribeCurrentUserToRouteVisits(routeId));
    },

    onViewLinksClick: (page)=> { 
      dispatch(openPageDetails(page, 'links'));
    }
  }
);

const PagePublishFlowModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PagePublishFlow);

PagePublishFlowModal.editorModalName = 'PagePublishFlowModal';

export default PagePublishFlowModal;
